import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-bootstrap/Carousel';

const servicios = [
  {
    titulo: 'Guardia de seguridad armada',
    descripcion: 'Contamos con personal altamente capacitado y autorizado para portar armas de fuego, ideal para custodiar instalaciones críticas, bancos o eventos de alto perfil.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Guardia de seguridad armada',
  },
  {
    titulo: 'Guardia de seguridad sin arma',
    descripcion: 'Ofrecemos vigilancia profesional sin armamento para empresas, edificios, escuelas y eventos que requieren presencia disuasoria y control de accesos.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Guardia de seguridad sin arma',
  },
  {
    titulo: 'Servicio de recorrido preventivo',
    descripcion: 'Realizamos patrullajes programados por personal motorizado o a pie, orientados a prevenir situaciones sospechosas en zonas residenciales, industriales y comerciales.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Servicio de recorrido preventivo',
  },
  {
    titulo: 'Instalación y mantenimiento técnico',
    descripcion: 'Brindamos instalación profesional y mantenimiento de alarmas, cámaras, sensores, sistemas de control de acceso y más, asegurando el óptimo funcionamiento de tus dispositivos.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Instalación y mantenimiento técnico',
  },
  {
    titulo: 'Monitoreo 24/7',
    descripcion: 'Nuestro centro de monitoreo opera las 24 horas, los 365 días del año, vigilando señales de alarma y respondiendo ante cualquier situación en tiempo real.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Monitoreo 24/7',
  },
  {
    titulo: 'Atención de eventos de emergencia',
    descripcion: 'Intervenimos rápidamente ante activaciones de alarmas, alertas de pánico o emergencias reportadas, coordinando con servicios públicos si es necesario.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Atención de eventos de emergencia',
  },
  {
    titulo: 'Transporte de valores',
    descripcion: 'Servicio seguro de traslado de dinero, documentos confidenciales u objetos de valor mediante vehículos blindados y escolta especializada.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Transporte de valores',
  },
  {
    titulo: 'Consultoría en seguridad',
    descripcion: 'Realizamos auditorías, análisis de riesgos y asesoramiento personalizado para implementar soluciones integrales de seguridad física y electrónica.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Consultoría en seguridad',
  },
  {
    titulo: 'Seguridad para eventos',
    descripcion: 'Planificamos y ejecutamos estrategias de seguridad para conciertos, ferias, conferencias y otros eventos, controlando accesos y garantizando el orden.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Seguridad para eventos',
  },
  {
    titulo: 'Supervisión operativa',
    descripcion: 'Contamos con supervisores que controlan en tiempo real el cumplimiento del servicio, rutas de patrullaje y desempeño del personal en campo.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Supervisión operativa',
  },
  {
    titulo: 'Pulsadores de pánico para residenciales',
    descripcion: 'Implementamos pulsadores de emergencia conectados a nuestro centro de monitoreo, ideales para residenciales de adultos mayores, brindando respuesta inmediata.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Pulsadores de pánico para residenciales',
  },
  {
    titulo: 'Soluciones para hogares inteligentes',
    descripcion: 'Transformamos tu hogar con tecnología smart: cerraduras electrónicas, luces automatizadas, sensores inteligentes, y control total desde tu smartphone.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Soluciones para hogares inteligentes',
  },
  {
    titulo: 'Rastreo de vehículos',
    descripcion: 'Ofrecemos soluciones de rastreo satelital en tiempo real para vehículos personales y flotas comerciales, con alertas y geocercas configurables.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Rastreo de vehículos',
  },
  {
    titulo: 'Wi-Fi móvil y conectividad',
    descripcion: 'Proveemos equipos y soluciones de conectividad inalámbrica en móviles o lugares sin infraestructura, asegurando conexión constante para sistemas de seguridad.',
    imagen: '/img/services/guardia.jpg',
    alt: 'Wi-Fi móvil y conectividad',
  },
];


function Servicios() {
  return (
    <>
      <h1 className="mb-4 text-center text-white ">Nuestros Servicios</h1>

      <Carousel fade interval={10000}>
        {servicios.map((servicio, index) => (
          <Carousel.Item key={index}>
            <img
              className="d-block w-100 rounded"
              src={servicio.imagen}
              alt={servicio.titulo}
            />
            <Carousel.Caption className="bg-dark bg-opacity-75 p-3 rounded">
              <h5>{servicio.titulo}</h5>
              <p>{servicio.descripcion}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
}

export default Servicios;
